import { DEFAULT_DATASET_ID } from '../../constants';
import { AdSlot } from '../../entities/ad-slot';
import { AdSlotConstraint } from '../../entities/ad-slot-constraint';
import { AdSlotSettings } from '../../entities/ad-slot-settings';
import { PublicSettings } from '../../types';
import { defineOwnProperties } from '../../utils/object';
import { ApplicationContext } from '../context/application.context';
import { Injectable } from '../dependency-injection/decorators';

@Injectable()
export class AdSlotResolver {
  public constructor (
    private readonly applicationContext: ApplicationContext,
  ) {
  }

  public async resolve (config: PublicSettings['adSlots'][number]): Promise<AdSlot> {
    const adSlot = new AdSlot();

    defineOwnProperties<AdSlot>(adSlot, {
      id: config.identifier,
      creativeType: config.creativeType,
    });

    // Always resolve the datasetId
    config.settings.datasetId = config.settings.datasetId
      ?? this.applicationContext.getApplicationConfig().datasetId
      ?? DEFAULT_DATASET_ID;

    const adSlotSettings = new AdSlotSettings();
    defineOwnProperties<AdSlotSettings, PublicSettings['adSlots'][number]['settings']>(adSlotSettings, config.settings);

    adSlot.setSettings(adSlotSettings);

    for (const constraint of config.constraints) {
      const adSlotConstraint = new AdSlotConstraint();
      defineOwnProperties<AdSlotConstraint, PublicSettings['adSlots'][number]['constraints'][number]>(
        adSlotConstraint,
        constraint,
      );

      adSlot.addConstraint(adSlotConstraint);
    }

    return adSlot;
  }
}
